// removed by extract-text-webpack-plugin
module.exports = {"githubCorner":"githubCorner--2_GDu","octoArm":"octoArm--2sxD7","octocat-wave":"octocat-wave--38DtJ"};


//////////////////
// WEBPACK FOOTER
// ./src/GithubCorner/GithubCorner.css
// module id = RRR4
// module chunks = 1